// extracted by mini-css-extract-plugin
export var actionIcon = "_un-0";